/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Pagination_PreviousInputs */

const id_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebelumnya`)
};

const ms_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebelum`)
};

const da_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forrige`)
};

const de_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorherige`)
};

const en_us2_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

const es_es2_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const es_mx2_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const fil_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nakaraan`)
};

const fr_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Précédent`)
};

const it_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precedente`)
};

const hu_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Előző`)
};

const nl_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorige`)
};

const no_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forrige`)
};

const pl_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poprzednia`)
};

const pt_br2_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

const pt_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const ro_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const fi_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edellinen`)
};

const sv_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Föregående`)
};

const vi_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trước`)
};

const tr_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önceki`)
};

const cs_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Předchozí`)
};

const bg_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предишен`)
};

const ru_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назад`)
};

const uk_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назад`)
};

const ar_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السابق`)
};

const hi_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछला`)
};

const th_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ก่อนหน้า`)
};

const ja_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前へ`)
};

const zh_cn2_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

const zh_hant1_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

const ko_ui_pagination_previous = /** @type {(inputs: Ui_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

/**
* | output |
* | --- |
* | "Previous" |
*
* @param {Ui_Pagination_PreviousInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const ui_pagination_previous = /** @type {((inputs?: Ui_Pagination_PreviousInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Pagination_PreviousInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_ui_pagination_previous(inputs)
	if (locale === "ms") return ms_ui_pagination_previous(inputs)
	if (locale === "da") return da_ui_pagination_previous(inputs)
	if (locale === "de") return de_ui_pagination_previous(inputs)
	if (locale === "en-US") return en_us2_ui_pagination_previous(inputs)
	if (locale === "es-ES") return es_es2_ui_pagination_previous(inputs)
	if (locale === "es-MX") return es_mx2_ui_pagination_previous(inputs)
	if (locale === "fil") return fil_ui_pagination_previous(inputs)
	if (locale === "fr") return fr_ui_pagination_previous(inputs)
	if (locale === "it") return it_ui_pagination_previous(inputs)
	if (locale === "hu") return hu_ui_pagination_previous(inputs)
	if (locale === "nl") return nl_ui_pagination_previous(inputs)
	if (locale === "no") return no_ui_pagination_previous(inputs)
	if (locale === "pl") return pl_ui_pagination_previous(inputs)
	if (locale === "pt-BR") return pt_br2_ui_pagination_previous(inputs)
	if (locale === "pt") return pt_ui_pagination_previous(inputs)
	if (locale === "ro") return ro_ui_pagination_previous(inputs)
	if (locale === "fi") return fi_ui_pagination_previous(inputs)
	if (locale === "sv") return sv_ui_pagination_previous(inputs)
	if (locale === "vi") return vi_ui_pagination_previous(inputs)
	if (locale === "tr") return tr_ui_pagination_previous(inputs)
	if (locale === "cs") return cs_ui_pagination_previous(inputs)
	if (locale === "bg") return bg_ui_pagination_previous(inputs)
	if (locale === "ru") return ru_ui_pagination_previous(inputs)
	if (locale === "uk") return uk_ui_pagination_previous(inputs)
	if (locale === "ar") return ar_ui_pagination_previous(inputs)
	if (locale === "hi") return hi_ui_pagination_previous(inputs)
	if (locale === "th") return th_ui_pagination_previous(inputs)
	if (locale === "ja") return ja_ui_pagination_previous(inputs)
	if (locale === "zh-CN") return zh_cn2_ui_pagination_previous(inputs)
	if (locale === "zh-Hant") return zh_hant1_ui_pagination_previous(inputs)
	return ko_ui_pagination_previous(inputs)
});
export { ui_pagination_previous as "ui.pagination.previous" }